<style>
  :host {
    font-family:  Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 14px;
    color: #333;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 8px 0;
  }

  p {
    margin: 0;
  }

  .spacer {
    flex: 1;
  }

  .toolbar {
    height: 60px;
    display: flex;
    align-items: center;
    background-color: #fafafa;
    color: #000df9;
    font-weight: 500;
  }

  .toolbar img {
    margin: 0 16px;
  }

  .toolbar #twitter-logo {
    height: 40px;
    margin: 0 16px;
  }

  .toolbar #twitter-logo:hover {
    opacity: 0.8;
  }

  .navigation-bar {
    margin-left: 20px;
  }
  .navigation-bar >  a {
    margin: 0 20px;
    display: inline-block;
  }

</style>


<div class="content" role="main">

<router-outlet></router-outlet>

<!-- Footer -->
<footer style="margin-top: 50px">
  Do you like KaDeck? <a href="https://twitter.com/xeotekgmbh" target="_blank" rel="noopener">&nbsp; Let us know on Twitter.&nbsp;
  <svg style="display:inline-block;fill:currentcolor;height:40px;color:#1da1f2;width:20px;" viewBox="0 0 24 24"><g>
    <path d="M23.643 4.937c-.835.37-1.732.62-2.675.733a4.67 4.67 0 0 0 2.048-2.578 9.3 9.3 0 0 1-2.958 1.13 4.66 4.66 0 0 0-7.938 4.25 13.229 13.229 0 0 1-9.602-4.868c-.4.69-.63 1.49-.63 2.342A4.66 4.66 0 0 0 3.96 9.824a4.647 4.647 0 0 1-2.11-.583v.06a4.66 4.66 0 0 0 3.737 4.568 4.692 4.692 0 0 1-2.104.08 4.661 4.661 0 0 0 4.352 3.234 9.348 9.348 0 0 1-5.786 1.995 9.5 9.5 0 0 1-1.112-.065 13.175 13.175 0 0 0 7.14 2.093c8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602a9.47 9.47 0 0 0 2.323-2.41z"></path></g></svg>
</a>
  <!--      <a href="https://twitter.com/xeotekgmbh" target="_blank" rel="noopener">-->
  <!--        <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">-->
  <!--          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="#1976d2"/>-->
  <!--          <path d="M0 0h24v24H0z" fill="none"/>-->
  <!--        </svg>-->
  <!--      </a>-->

</footer>
<p style="margin-top: 30px; display: block;">
  Copyright <a target="_blank" href="https://www.xeotek.com" style="color: #5f6c7f">Xeotek GmbH</a> 2022. All rights reserved.
</p>
  <svg id="clouds" viewBox="-1.5 529.754 603 71.746" style="color: #89abc6"  width="2611.084" height="685.677">
    <path d=" M 0 500 Q 66.018 533.115 153.816 571.235 C 241.613 599.355 293.526 571.416 310 560 C 346.774 534.516 402.903 510.645 450 560 Q 497.097 609.355 600 560 L 600 600 L 0 600 L 0 560 Z "></path>
  </svg>
<!--<svg id="clouds" style="color: #e1eef8" alt="Gray Clouds Background" xmlns="http://www.w3.org/2000/svg" width="2611.084" height="485.677"-->
<!--     viewBox="0 0 2611.084 485.677">-->
<!--  <path id="Path_39" data-name="Path 39"-->
<!--        d="M2379.709,863.793c10-93-77-171-168-149-52-114-225-105-264,15-75,3-140,59-152,133-30,2.83-66.725,9.829-93.5,26.25-26.771-16.421-63.5-23.42-93.5-26.25-12-74-77-130-152-133-39-120-212-129-264-15-54.084-13.075-106.753,9.173-138.488,48.9-31.734-39.726-84.4-61.974-138.487-48.9-52-114-225-105-264,15a162.027,162.027,0,0,0-103.147,43.044c-30.633-45.365-87.1-72.091-145.206-58.044-52-114-225-105-264,15-75,3-140,59-152,133-53,5-127,23-130,83-2,42,35,72,70,86,49,20,106,18,157,5a165.625,165.625,0,0,0,120,0c47,94,178,113,251,33,61.112,8.015,113.854-5.72,150.492-29.764a165.62,165.62,0,0,0,110.861-3.236c47,94,178,113,251,33,31.385,4.116,60.563,2.495,86.487-3.311,25.924,5.806,55.1,7.427,86.488,3.311,73,80,204,61,251-33a165.625,165.625,0,0,0,120,0c51,13,108,15,157-5a147.188,147.188,0,0,0,33.5-18.694,147.217,147.217,0,0,0,33.5,18.694c49,20,106,18,157,5a165.625,165.625,0,0,0,120,0c47,94,178,113,251,33C2446.709,1093.793,2554.709,922.793,2379.709,863.793Z"-->
<!--        transform="translate(142.69 -634.312)" fill="#89abc6"/>-->
<!--</svg>-->
<div class="background-bottom"></div>
</div>
